import Roles from '@/auth/roles';
import PlayerForm from './player-form';
import PlayerList from './player-list';
import PlayerHistoryFull from './player-history/player-history-full/player-history-full';
import PlayerHistorySingle from './player-history/player-history-single/player-history-single';
import PlayerShow from './player-show';

const roles = Roles.values;

export default [
  {
    name: 'playerList',
    path: 'player',
    component: PlayerList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.playerViewer.id,
        roles.playerEditor.id
      ]
    }
  },
  {
    name: 'playerNew',
    path: 'player/new',
    component: PlayerForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.playerEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'playerEdit',
    path: 'player/:id/edit',
    component: PlayerForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.playerEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'playerHistorySingle',
    path: 'player/:id/history',
    component: PlayerHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'playerHistoryFull',
    path: 'player/history',
    component: PlayerHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'playerShow',
    path: 'player/:id',
    component: PlayerShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.playerViewer.id,
        roles.playerEditor.id,
        roles.clubManager.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/player/player-routes.js